import { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { configureApiClient } from './client';

export function ApiClientSetup({ children }: { children: React.ReactNode }) {
  const { getAccessToken } = useAuth();
  useEffect(() => {
    configureApiClient(getAccessToken);
  }, [getAccessToken]);
  return <>{children}</>;
}
